import NewConnectionRequest from './NewConnectionRequest';
export default NewConnectionRequest;



// WEBPACK FOOTER //
// ./src/components/App/ConnectionRequestsDashboard/NewConnectionRequest/index.js